<ng-container *ngIf="routerLink; else buttonEl">
  <a
    [routerLink]="routerLink"
    class="app-back-button"
    [ngClass]="customClass"
    (click)="handleClick($event)"
  >
    <svg class="app-back-button__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <line x1="19" y1="12" x2="5" y2="12"></line>
      <polyline points="12 19 5 12 12 5"></polyline>
    </svg>
    <span class="app-back-button__text">{{ label }}</span>
  </a>
</ng-container>

<ng-template #buttonEl>
  <button
    type="button"
    class="app-back-button"
    [ngClass]="customClass"
    (click)="handleClick($event)"
  >
    <svg class="app-back-button__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <line x1="19" y1="12" x2="5" y2="12"></line>
      <polyline points="12 19 5 12 12 5"></polyline>
    </svg>
    <span class="app-back-button__text">{{ label }}</span>
  </button>
</ng-template>
